import { refItem } from "@tc/drizzle-v2"
import { eq, and } from "drizzle-orm"
import {
  MessageAttributeValue,
  SQSClient,
  SendMessageCommand,
} from "@aws-sdk/client-sqs"
import { DbTransaction } from "@tc/middy-decorators"
import { GenericItemDoc } from "../types/reference-data"
import { searchBuilderLog } from "../utils/logger"

const sqs_client = new SQSClient({})
const queue_url = process.env["WINE_EU_CATEGORIES_QUEUE_URL"]

export const getWineEUCategoriesData = async (
  tx: DbTransaction,
  id: string,
): Promise<GenericItemDoc | undefined> => {
  const [row] = await tx
    .select({
      id: refItem.id,
      itemCode: refItem.itemCode,
      itemName: refItem.itemName,
    })
    .from(refItem)
    .where(
      and(
        eq(refItem.id, parseInt(id)),
        eq(refItem.listCode, "EUWineCategories"),
        eq(refItem.active, true),
      ),
    )

  if (!row) {
    console.error(`Wine EU category with id ${id} not found/active`)
    return
  }

  const doc: GenericItemDoc = {
    id: row.itemCode,
    search_id: row.itemCode,
    label: row.itemName || "",
  }

  searchBuilderLog.debug({ document: doc })

  return doc
}

export const saveWineEUCategoriesToSearch = async (
  tx: DbTransaction,
  id: string,
  collectionName: string,
  options?: { returnDoc?: boolean },
): Promise<void> => {
  const doc = await getWineEUCategoriesData(tx, id)

  if (!doc || Object.keys(doc).length === 0) {
    console.error(`Failed to prepare document for id: ${id}`)
    return
  }

  if (options?.returnDoc) return doc as never

  const attributes: Record<string, MessageAttributeValue> = {
    collection: {
      StringValue: collectionName,
      DataType: "String",
    },
  }

  const command = new SendMessageCommand({
    QueueUrl: queue_url,
    MessageBody: JSON.stringify(doc),
    MessageAttributes: attributes,
  })

  await sqs_client.send(command)
}
